<template>
  <v-card flat class="dark">
    <v-tabs
      v-model="active_tab"
      class="my-0"
      :slider-color="sliderColor"
      centered
    >
      <v-tab :key="1">Market settings</v-tab>
      <v-tab :key="2">Allocation info</v-tab>
      <v-tab-item :key="1">
        <div style="display: table; width: 100%">
          <span style="display: table-cell; width: 20px;">
            <span
              :class="['vertical']"
              :style="settingsVertical"
              v-html="market_pair"
            ></span>
          </span>
          <span style="display: table-cell; width: 100%; float: left;">
            <div ref="settings-box" style="float: inline-start; width: 100%;">
            <v-card-text v-if="allowShowSettingTab" >
              <p class="title text-xs-center">Basic settings</p>

              <p class="setting-title">
                Min. trade profit percentage
                <v-icon
                  class="vertical-align-middle icon-for-information"
                  style="font-size: 14px; margin-left: 4px;"
                  @click="
                    () => {
                      infoAlert(
                        $t('settings.min_trade_profit_pct_title'),
                        $t('settings.min_trade_profit_pct_text')
                      );
                    }
                  "
                  >fa-info-circle
                </v-icon>
              </p>
              <span class="setting-description" style="padding-left: 24px;">
                You can automatically follow the GSMG optimised value or set your
                own
                <v-icon
                  class="vertical-align-middle icon-for-information"
                  style="font-size: 14px; margin-left: 4px;"
                  @click="
                    () => {
                      infoAlert(
                        $t(
                          'information.gsmg_optimised_min_trade_profit_percentage.title'
                        ),
                        $t(
                          'information.gsmg_optimised_min_trade_profit_percentage.description'
                        )
                      );
                    }
                  "
                  >fa-info-circle
                </v-icon>
              </span>

              <div>
                <v-tooltip
                  top
                  :disabled="
                    userSubscriptionHasMarketFeature(
                      marketFeatures.TRACK_OPTIMISED_MIN_TRADE_PROFIT
                    ) ||
                      userSubscriptionHasMarketFeature(
                        marketFeatures.MIN_TRADE_PROFIT_PERCENTAGE
                      )
                  "
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm9 style="padding-left: 24px;">
                          <div
                            style="width: 90%; padding-top: 8px;"
                            :class="[
                              'my-2',
                              'section',
                              track_mtp_pct.showSaveButton ||
                              min_trade_profit_pct.showDataSaved
                                ? 'input-changed-section'
                                : '',
                              track_mtp_pct.showDataSaved ||
                              min_trade_profit_pct.showDataSaved
                                ? 'input-saved-section'
                                : '',
                              track_mtp_pct.showDataSavedError ||
                              min_trade_profit_pct.showDataSavedError
                                ? 'input-error-section'
                                : ''
                            ]"
                          >
                            <v-layout row wrap>
                              <v-flex xs12 sm4>
                                <v-checkbox
                                  v-if="market.enabled"
                                  v-model="track_mtp_pct_invert"
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.TRACK_OPTIMISED_MIN_TRADE_PROFIT
                                    )
                                  "
                                  :error-messages="
                                    track_mtp_pct.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :label="`Own:`"
                                  @change="
                                    changedMarketSettings(
                                      market.name,
                                      'track_mtp_pct'
                                    )
                                  "
                                >
                                </v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm8>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12>
                                    <v-form
                                      v-model="min_trade_profit_pct_is_valid"
                                    >
                                      <div
                                        style="display: inline-block; width: 100%;"
                                      >
                                        <v-text-field
                                          v-if="market.enabled"
                                          v-model="market.min_trade_profit_pct"
                                          :disabled="
                                            !userSubscriptionHasMarketFeature(
                                              marketFeatures.MIN_TRADE_PROFIT_PERCENTAGE
                                            ) ||
                                              (market.track_mtp_pct !== 0 &&
                                                market.track_mtp_pct !== false)
                                          "
                                          type="number"
                                          :rules="[
                                            x =>
                                              !!x ||
                                              $t(
                                                'settings.min_trade_profit_pct_error'
                                              ),
                                            x =>
                                              x >= 0.01 ||
                                              $t(
                                                'settings.min_trade_profit_pct_error'
                                              )
                                          ]"
                                          suffix="%"
                                          min="1"
                                          max="100"
                                          required
                                          :class="[
                                            'number-input',
                                            'icon-for-information'
                                          ]"
                                          style="padding: 0px; margin: 0px;"
                                          :error-messages="
                                            min_trade_profit_pct.showDataSavedError
                                              ? 'Error saving, please try again'
                                              : ''
                                          "
                                          :append-icon="
                                            market.min_trade_profit_pct !== 1
                                              ? 'fa-times'
                                              : ''
                                          "
                                          @click:append="
                                            () => {
                                              market.min_trade_profit_pct = 1;
                                              changedMarketSettings(
                                                market.name,
                                                'track_mtp_pct'
                                              );
                                            }
                                          "
                                          @input="
                                            changedMarketSettings(
                                              market.name,
                                              'min_trade_profit_pct'
                                            );
                                            changedMarketSettings(
                                              market.name,
                                              'track_mtp_pct'
                                            );
                                          "
                                        ></v-text-field>
                                      </div>
                                    </v-form>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 sm4 align-center>
                                <v-checkbox
                                  v-if="market.enabled"
                                  v-model="market.track_mtp_pct"
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.TRACK_OPTIMISED_MIN_TRADE_PROFIT
                                    )
                                  "
                                  :error-messages="
                                    track_mtp_pct.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :label="`Follow, currently at:`"
                                  @change="
                                    changedMarketSettings(
                                      market.name,
                                      'track_mtp_pct'
                                    )
                                  "
                                >
                                </v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm8>
                                <div style="width: 100%;">
                                  <span :class="['mtp-pct--title']">
                                    {{
                                      $options.filters.roundNumber(
                                        market.market_knowledge_b.mtp_pct,
                                        2
                                      )
                                    }}
                                    %
                                  </span>
                                </div>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm3 class="justify-center">
                          <v-btn
                            v-if="
                              track_mtp_pct.showSaveButton ||
                                min_trade_profit_pct.showSaveButton
                            "
                            small
                            class="btn-reset"
                            @click="
                              resetSettings(market.name, 'min_trade_profit_pct');
                              resetSettings(market.name, 'track_mtp_pct');
                            "
                          >
                            Reset
                          </v-btn>
                          <v-btn
                            v-if="
                              track_mtp_pct.showSaveButton ||
                                min_trade_profit_pct.showSaveButton
                            "
                            small
                            class="btn-save"
                            @click="
                              saveMarket(
                                market.name,
                                'track_mtp_pct',
                                market.track_mtp_pct
                              );
                              saveMarket(
                                market.name,
                                'min_trade_profit_pct',
                                market.min_trade_profit_pct
                              );
                            "
                          >
                            Save
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                  <span
                    >This feature is not available in your current
                    subscription.</span
                  >
                </v-tooltip>
              </div>

              <div>
                <v-tooltip
                  top
                  :disabled="
                    userSubscriptionHasMarketFeature(
                      marketFeatures.TRADE_AGGRESSIVENESS
                    )
                  "
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm9>
                          <v-form v-model="aggressiveness_pct_is_valid">
                            <div style="display: inline-block; width: 90%;">
                              <v-text-field
                                v-if="market.enabled"
                                :value="market.aggressiveness_pct"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.TRADE_AGGRESSIVENESS
                                  )
                                "
                                type="number"
                                label="Trade engine aggressiveness"
                                :rules="[
                                  x =>
                                    !!x ||
                                    $t(
                                      'settings.trade_engine_aggressiveness_error'
                                    ),
                                  x =>
                                    (x >= 1 && x <= 220) ||
                                    $t(
                                      'settings.trade_engine_aggressiveness_error'
                                    ),
                                  x =>
                                    !userSubscriptionMaxAggressiveness ||
                                    x <= userSubscriptionMaxAggressiveness ||
                                    user.id <= 10536 ||
                                    'The limit for trade engine aggressiveness in your subscription is ' +
                                      userSubscriptionMaxAggressiveness
                                ]"
                                suffix="%"
                                min="1"
                                max="220"
                                required
                                :class="[
                                  'number-input',
                                  'vertical-align-middle',
                                  'icon-for-information',
                                  aggressiveness_pct.showSaveButton
                                    ? inputChanged
                                    : '',
                                  aggressiveness_pct.showDataSaved
                                    ? showDataSaved
                                    : '',
                                  !aggressiveness_pct_is_valid
                                    ? showInputError
                                    : '',
                                  aggressiveness_pct.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  aggressiveness_pct.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                :append-icon="
                                  market.aggressiveness_pct !== 1
                                    ? 'fa-times'
                                    : ''
                                "
                                @click:append="
                                  () => {
                                    market.aggressiveness_pct = 1;
                                    changedMarketSettings(
                                      market.name,
                                      'aggressiveness_pct'
                                    );
                                  }
                                "
                                @input="
                                  value =>
                                    setAggressiveness(
                                      market,
                                      value,
                                      'aggressiveness_pct'
                                    )
                                "
                              ></v-text-field>
                            </div>
                            <div style="display: inline-block;">
                              <v-icon
                                class="vertical-align-middle icon-for-information"
                                style="font-size: 18px; margin-left: 4px;"
                                @click="
                                  () => {
                                    infoAlert(
                                      $t(
                                        'settings.trade_engine_aggressiveness_title'
                                      ),
                                      $t(
                                        'settings.trade_engine_aggressiveness_text'
                                      )
                                    );
                                  }
                                "
                                >fa-info-circle
                              </v-icon>
                            </div>
                          </v-form>
                        </v-flex>
                        <v-flex xs12 sm3 class="justify-center">
                          <v-btn
                            v-if="
                              aggressiveness_pct.showSaveButton &&
                                aggressiveness_pct_is_valid
                            "
                            small
                            class="btn-reset"
                            @click="
                              resetSettings(market.name, 'aggressiveness_pct')
                            "
                          >
                            Reset
                          </v-btn>
                          <v-btn
                            v-if="
                              aggressiveness_pct.showSaveButton &&
                                aggressiveness_pct_is_valid
                            "
                            small
                            class="btn-save"
                            @click="
                              saveMarket(
                                market.name,
                                'aggressiveness_pct',
                                market.aggressiveness_pct
                              )
                            "
                          >
                            Save
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                  <span
                    >This feature is not available in your current
                    subscription.</span
                  >
                </v-tooltip>
              </div>
              <div>
                <v-tooltip
                  top
                  :disabled="
                    userSubscriptionHasMarketFeature(marketFeatures.HODL_AMOUNT)
                  "
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm9>
                          <v-form v-model="hodl_amount_is_valid">
                            <div style="display: inline-block; width: 90%;">
                              <v-text-field
                                v-if="market.enabled"
                                v-model="market.hodl_amount"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.HODL_AMOUNT
                                  )
                                "
                                :label="'HODL amount'"
                                :suffix="market.target_currency"
                                :rules="[
                                  x =>
                                    /^\d+(\.\d{1,8})*$/.test(x) ||
                                    $t(
                                      'settings.hodl_amount_allows_numbers_error'
                                    )
                                ]"
                                :class="[
                                  'number-input',
                                  hodl_amount.showSaveButton ? inputChanged : '',
                                  hodl_amount.showDataSaved ? showDataSaved : '',
                                  !hodl_amount_is_valid ? showInputError : '',
                                  hodl_amount.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  hodl_amount.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                :append-icon="
                                  market.hodl_amount !== 0 ? 'fa-times' : ''
                                "
                                @click:append="
                                  () => {
                                    market.hodl_amount = 0;
                                    changedMarketSettings(
                                      market.name,
                                      'hodl_amount'
                                    );
                                  }
                                "
                                @input="
                                  changedMarketSettings(
                                    market.name,
                                    'hodl_amount'
                                  )
                                "
                              ></v-text-field>
                            </div>
                            <div style="display: inline-block;">
                              <v-icon
                                class="vertical-align-middle icon-for-information"
                                style="font-size: 18px; margin-left: 4px;"
                                @click="
                                  () => {
                                    infoAlert(
                                      $t('settings.hodl_amount_title'),
                                      $t('settings.hodl_amount_text')
                                    );
                                  }
                                "
                                >fa-info-circle
                              </v-icon>
                            </div>
                          </v-form>
                        </v-flex>
                        <v-flex xs12 sm3 class="justify-center">
                          <v-btn
                            v-if="
                              hodl_amount.showSaveButton && hodl_amount_is_valid
                            "
                            small
                            class="btn-reset"
                            @click="resetSettings(market.name, 'hodl_amount')"
                          >
                            Reset
                          </v-btn>
                          <v-btn
                            v-if="
                              hodl_amount.showSaveButton && hodl_amount_is_valid
                            "
                            small
                            class="btn-save"
                            @click="
                              saveMarket(
                                market.name,
                                'hodl_amount',
                                market.hodl_amount
                              )
                            "
                          >
                            Save
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </div>
                  </template>
                  <span
                    >This feature is not available in your current
                    subscription.</span
                  >
                </v-tooltip>
              </div>
              <p class="title text-xs-center">
                Advanced settings (<a
                  href="#"
                  @click.prevent="toggleShowAdvanced()"
                  >{{ advancedTitle }}</a
                >)
              </p>
              <div v-if="showAdvanced" class="advanced">
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.MAX_BUY_PRICE
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-form v-model="max_buy_price_is_valid">
                              <div style="display: inline-block; width: 90%;">
                                <v-text-field
                                  v-if="market.enabled"
                                  v-model="market.max_buy_price"
                                  :class="[
                                    'number-input',
                                    'vertical-align-middle',
                                    'icon-for-information',
                                    max_buy_price.showSaveButton
                                      ? inputChanged
                                      : '',
                                    max_buy_price.showDataSaved
                                      ? showDataSaved
                                      : '',
                                    !max_buy_price_is_valid ? showInputError : '',
                                    max_buy_price.showDataSavedError
                                      ? showInputError
                                      : ''
                                  ]"
                                  :error-messages="
                                    max_buy_price.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.MAX_BUY_PRICE
                                    )
                                  "
                                  :rules="[
                                    x =>
                                      (x && x > 0) ||
                                      !x ||
                                      $t('settings.max_buy_price_error')
                                  ]"
                                  label="Max. buy price"
                                  :suffix="market.base_currency"
                                  min="0"
                                  type="number"
                                  :append-icon="
                                    market.max_buy_price !== '' &&
                                    market.max_buy_price !== null
                                      ? 'fa-times'
                                      : ''
                                  "
                                  @click:append="
                                    () => {
                                      market.max_buy_price = '';
                                      changedMarketSettings(
                                        market.name,
                                        'max_buy_price'
                                      );
                                    }
                                  "
                                  @input="
                                    changedMarketSettings(
                                      market.name,
                                      'max_buy_price'
                                    )
                                  "
                                ></v-text-field>
                              </div>
                              <div style="display: inline-block;">
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 18px; margin-left: 4px;"
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('settings.max_buy_price_title'),
                                        $t('settings.max_buy_price_text')
                                      );
                                    }
                                  "
                                  >fa-info-circle
                                </v-icon>
                              </div>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="
                                max_buy_price.showSaveButton &&
                                  max_buy_price_is_valid
                              "
                              small
                              class="btn-reset"
                              @click="resetSettings(market.name, 'max_buy_price')"
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="
                                max_buy_price.showSaveButton &&
                                  max_buy_price_is_valid
                              "
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'max_buy_price',
                                  market.max_buy_price
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.MIN_SELL_PRICE
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-form v-model="min_sell_price_is_valid">
                              <div style="display: inline-block; width: 90%;">
                                <v-text-field
                                  v-if="
                                    market.enabled &&
                                      user.subscription_name !== 'Herring'
                                  "
                                  v-model="market.min_sell_price"
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.MIN_SELL_PRICE
                                    )
                                  "
                                  type="number"
                                  label="Min. sell price"
                                  min="0"
                                  :suffix="market.base_currency"
                                  :rules="[
                                    x =>
                                      (x && x > 0) ||
                                      !x ||
                                      $t('settings.min_sell_price_error')
                                  ]"
                                  :class="[
                                    'number-input',
                                    'vertical-align-middle',
                                    'icon-for-information',
                                    min_sell_price.showSaveButton
                                      ? inputChanged
                                      : '',
                                    min_sell_price.showDataSaved
                                      ? showDataSaved
                                      : '',
                                    !min_sell_price_is_valid
                                      ? showInputError
                                      : '',
                                    min_sell_price.showDataSavedError
                                      ? showInputError
                                      : ''
                                  ]"
                                  :error-messages="
                                    min_sell_price.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :append-icon="
                                    market.min_sell_price !== '' &&
                                    market.min_sell_price !== null
                                      ? 'fa-times'
                                      : ''
                                  "
                                  @click:append="
                                    () => {
                                      market.min_sell_price = '';
                                      changedMarketSettings(
                                        market.name,
                                        'min_sell_price'
                                      );
                                    }
                                  "
                                  @input="
                                    changedMarketSettings(
                                      market.name,
                                      'min_sell_price'
                                    )
                                  "
                                ></v-text-field>
                              </div>
                              <div style="display: inline-block;">
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 18px; margin-left: 4px;"
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('settings.min_sell_price_title'),
                                        $t('settings.min_sell_price_text')
                                      );
                                    }
                                  "
                                  >fa-info-circle
                                </v-icon>
                              </div>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="
                                min_sell_price.showSaveButton &&
                                  min_sell_price_is_valid
                              "
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(market.name, 'min_sell_price')
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="
                                min_sell_price.showSaveButton &&
                                  min_sell_price_is_valid
                              "
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'min_sell_price',
                                  market.min_sell_price
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.MAX_SELL_PRICE_HINT
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-form v-model="max_sell_price_hint_is_valid">
                              <div style="display: inline-block; width: 90%;">
                                <v-text-field
                                  v-if="market.enabled"
                                  v-model="market.max_sell_price_hint"
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.MAX_SELL_PRICE_HINT
                                    )
                                  "
                                  type="number"
                                  label="Max. sell price"
                                  min="0"
                                  :suffix="market.base_currency"
                                  :rules="[
                                    x =>
                                      (x && x > 0) ||
                                      !x ||
                                      $t('settings.max_sell_price_hint_error')
                                  ]"
                                  :class="[
                                    'number-input',
                                    'vertical-align-middle',
                                    'icon-for-information',
                                    max_sell_price_hint.showSaveButton
                                      ? inputChanged
                                      : '',
                                    max_sell_price_hint.showDataSaved
                                      ? showDataSaved
                                      : '',
                                    !max_sell_price_hint_is_valid
                                      ? showInputError
                                      : '',
                                    max_sell_price_hint.showDataSavedError
                                      ? showInputError
                                      : ''
                                  ]"
                                  :error-messages="
                                    max_sell_price_hint.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :append-icon="
                                    market.max_sell_price_hint !== '' &&
                                    market.max_sell_price_hint !== null
                                      ? 'fa-times'
                                      : ''
                                  "
                                  @click:append="
                                    () => {
                                      market.max_sell_price_hint = '';
                                      changedMarketSettings(
                                        market.name,
                                        'max_sell_price_hint'
                                      );
                                    }
                                  "
                                  @input="
                                    changedMarketSettings(
                                      market.name,
                                      'max_sell_price_hint'
                                    )
                                  "
                                ></v-text-field>
                              </div>
                              <div style="display: inline-block;">
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 18px; margin-left: 4px;"
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('settings.max_sell_price_hint_title'),
                                        $t('settings.max_sell_price_hint_text')
                                      );
                                    }
                                  "
                                  >fa-info-circle
                                </v-icon>
                              </div>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="
                                max_sell_price_hint.showSaveButton &&
                                  max_sell_price_hint_is_valid
                              "
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(market.name, 'max_sell_price_hint')
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="
                                max_sell_price_hint.showSaveButton &&
                                  max_sell_price_hint_is_valid
                              "
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'max_sell_price_hint',
                                  market.max_sell_price_hint
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.TRAILING_SELL
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <div style="display: inline-block;">
                              <v-switch
                                v-if="market.enabled"
                                v-model="market.do_trailing_stop_loss"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.TRAILING_SELL
                                  )
                                "
                                :class="[
                                  'my-2',
                                  'vertical-align-middle',
                                  'icon-for-information',
                                  do_trailing_stop_loss.showSaveButton
                                    ? inputChanged
                                    : '',
                                  do_trailing_stop_loss.showDataSaved
                                    ? showDataSaved
                                    : '',
                                  do_trailing_stop_loss.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  do_trailing_stop_loss.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                label="Enable trailing sell"
                                @change="
                                  changedMarketSettings(
                                    market.name,
                                    'do_trailing_stop_loss'
                                  )
                                "
                              ></v-switch>
                            </div>
                            <div style="display: inline-block;">
                              <v-icon
                                class="vertical-align-middle icon-for-information"
                                style="font-size: 18px; margin-left: 4px;"
                                @click="
                                  () => {
                                    infoAlert(
                                      $t('settings.trailing_stop_loss_title'),
                                      $t('settings.trailing_stop_loss_text')
                                    );
                                  }
                                "
                                >fa-info-circle
                              </v-icon>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="do_trailing_stop_loss.showSaveButton"
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(
                                  market.name,
                                  'do_trailing_stop_loss'
                                )
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="do_trailing_stop_loss.showSaveButton"
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'do_trailing_stop_loss',
                                  market.do_trailing_stop_loss
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.TRAILING_BUY
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-switch
                              v-if="market.enabled"
                              v-model="market.do_trsl_buy"
                              :disabled="
                                !userSubscriptionHasMarketFeature(
                                  marketFeatures.TRAILING_BUY
                                )
                              "
                              :true-value="market.do_trsl_buy === 1 ? 1 : 2"
                              :false-value="0"
                              :class="[
                                'my-2',
                                do_trsl_buy.showSaveButton ? inputChanged : '',
                                do_trsl_buy.showDataSaved ? showDataSaved : '',
                                do_trsl_buy.showDataSavedError
                                  ? showInputError
                                  : ''
                              ]"
                              :error-messages="
                                do_trsl_buy.showDataSavedError
                                  ? 'Error saving, please try again'
                                  : ''
                              "
                              label="Enable trailing buy"
                              @change="
                                changedMarketSettings(market.name, 'do_trsl_buy')
                              "
                            ></v-switch>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="do_trsl_buy.showSaveButton"
                              small
                              class="btn-reset"
                              @click="resetSettings(market.name, 'do_trsl_buy')"
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="do_trsl_buy.showSaveButton"
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'do_trsl_buy',
                                  market.do_trsl_buy
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.ALLOW_BUYS_ABOVE_TRAILING_SELL
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <div style="display: inline-block;">
                              <v-switch
                                v-if="market.enabled"
                                v-model="market.allow_buy_above_trsl"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.ALLOW_BUYS_ABOVE_TRAILING_SELL
                                  )
                                "
                                :class="[
                                  'my-2',
                                  'vertical-align-middle',
                                  'icon-for-information',
                                  allow_buy_above_trsl.showSaveButton
                                    ? inputChanged
                                    : '',
                                  allow_buy_above_trsl.showDataSaved
                                    ? showDataSaved
                                    : '',
                                  allow_buy_above_trsl.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  allow_buy_above_trsl.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                label="Allow buys above trailing sell"
                                @change="
                                  changedMarketSettings(
                                    market.name,
                                    'allow_buy_above_trsl'
                                  )
                                "
                              ></v-switch>
                            </div>
                            <div style="display: inline-block;">
                              <v-icon
                                class="vertical-align-middle icon-for-information"
                                style="font-size: 18px; margin-left: 4px;"
                                @click="
                                  () => {
                                    infoAlert(
                                      $t('settings.allow_buy_above_trsl_title'),
                                      $t('settings.allow_buy_above_trsl_text')
                                    );
                                  }
                                "
                                >fa-info-circle
                              </v-icon>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="allow_buy_above_trsl.showSaveButton"
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(market.name, 'allow_buy_above_trsl')
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="allow_buy_above_trsl.showSaveButton"
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'allow_buy_above_trsl',
                                  market.allow_buy_above_trsl
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.BUY_ENTRY_MODULATION
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-form v-model="bem_pct_is_valid">
                              <div style="display: inline-block; width: 90%;">
                                <v-text-field
                                  v-if="market.enabled"
                                  v-model="market.bem_pct"
                                  :disabled="
                                    !userSubscriptionHasMarketFeature(
                                      marketFeatures.BUY_ENTRY_MODULATION
                                    )
                                  "
                                  type="number"
                                  label="Buy entry modulation"
                                  :rules="[
                                    x =>
                                      /-?\d{1,3}(\.\d+)?$/.test(x) ||
                                      $t('settings.bem_pct_error'),
                                    x =>
                                      (x >= -100 && x <= 100) ||
                                      $t('settings.bem_pct_error')
                                  ]"
                                  suffix="%"
                                  min="-100"
                                  max="100"
                                  required
                                  :class="[
                                    'number-input',
                                    'vertical-align-middle',
                                    'icon-for-information',
                                    bem_pct.showSaveButton ? inputChanged : '',
                                    bem_pct.showDataSaved ? showDataSaved : '',
                                    bem_pct.showDataSavedError
                                      ? showInputError
                                      : ''
                                  ]"
                                  :error-messages="
                                    bem_pct.showDataSavedError
                                      ? 'Error saving, please try again'
                                      : ''
                                  "
                                  :append-icon="
                                    market.bem_pct !== 0 ? 'fa-times' : ''
                                  "
                                  @click:append="
                                    () => {
                                      market.bem_pct = 0;
                                      changedMarketSettings(
                                        market.name,
                                        'bem_pct'
                                      );
                                    }
                                  "
                                  @input="
                                    changedMarketSettings(market.name, 'bem_pct')
                                  "
                                ></v-text-field>
                              </div>
                              <div style="display: inline-block;">
                                <v-icon
                                  class="vertical-align-middle icon-for-information"
                                  style="font-size: 18px; margin-left: 4px;"
                                  @click="
                                    () => {
                                      infoAlert(
                                        $t('settings.bem_pct_title'),
                                        $t('settings.bem_pct_text')
                                      );
                                    }
                                  "
                                  >fa-info-circle
                                </v-icon>
                              </div>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="bem_pct.showSaveButton && bem_pct_is_valid"
                              small
                              class="btn-reset"
                              @click="resetSettings(market.name, 'bem_pct')"
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="bem_pct.showSaveButton && bem_pct_is_valid"
                              small
                              class="btn-save"
                              @click="
                                saveMarket(market.name, 'bem_pct', market.bem_pct)
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.SURPLUS_SELLING
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <div style="display: inline-block;">
                              <v-switch
                                v-if="market.enabled"
                                v-model="market.do_surplus_selling"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.SURPLUS_SELLING
                                  )
                                "
                                :class="[
                                  'my-2',
                                  do_surplus_selling.showSaveButton
                                    ? inputChanged
                                    : '',
                                  do_surplus_selling.showDataSaved
                                    ? showDataSaved
                                    : '',
                                  do_surplus_selling.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  do_surplus_selling.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                label="Enable surplus selling"
                                @change="
                                  changedMarketSettings(
                                    market.name,
                                    'do_surplus_selling'
                                  )
                                "
                              ></v-switch>
                            </div>
                            <div style="display: inline-block;">
                              <v-icon
                                class="vertical-align-middle icon-for-information"
                                style="font-size: 18px; margin-left: 4px;"
                                @click="
                                  () => {
                                    infoAlert(
                                      $t('settings.surplus_selling_title'),
                                      $t('settings.surplus_selling_text')
                                    );
                                  }
                                "
                                >fa-info-circle
                              </v-icon>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="do_surplus_selling.showSaveButton"
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(market.name, 'do_surplus_selling')
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="do_surplus_selling.showSaveButton"
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'do_surplus_selling',
                                  market.do_surplus_selling
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip
                    top
                    :disabled="
                      userSubscriptionHasMarketFeature(
                        marketFeatures.SURPLUS_MIN_SELL_PRICE
                      )
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm9>
                            <v-form v-model="surplus_min_sell_price_is_valid">
                              <v-text-field
                                v-if="market.enabled"
                                v-model="market.surplus_min_sell_price"
                                :disabled="
                                  !userSubscriptionHasMarketFeature(
                                    marketFeatures.SURPLUS_MIN_SELL_PRICE
                                  )
                                "
                                type="number"
                                :label="'Min. surplus sell price'"
                                :suffix="market.base_currency"
                                min="0"
                                style="width:90%;"
                                :class="[
                                  'number-input',
                                  surplus_min_sell_price.showSaveButton
                                    ? inputChanged
                                    : '',
                                  surplus_min_sell_price.showDataSaved
                                    ? showDataSaved
                                    : '',
                                  !surplus_min_sell_price_is_valid
                                    ? showInputError
                                    : '',
                                  surplus_min_sell_price.showDataSavedError
                                    ? showInputError
                                    : ''
                                ]"
                                :error-messages="
                                  surplus_min_sell_price.showDataSavedError
                                    ? 'Error saving, please try again'
                                    : ''
                                "
                                :append-icon="
                                  market.surplus_min_sell_price !== '' &&
                                  market.surplus_min_sell_price !== null
                                    ? 'fa-times'
                                    : ''
                                "
                                @click:append="
                                  () => {
                                    market.surplus_min_sell_price = '';
                                    changedMarketSettings(
                                      market.name,
                                      'surplus_min_sell_price'
                                    );
                                  }
                                "
                                @input="
                                  changedMarketSettings(
                                    market.name,
                                    'surplus_min_sell_price'
                                  )
                                "
                              ></v-text-field>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 sm3 class="justify-center">
                            <v-btn
                              v-if="
                                surplus_min_sell_price.showSaveButton &&
                                  surplus_min_sell_price_is_valid
                              "
                              small
                              class="btn-reset"
                              @click="
                                resetSettings(
                                  market.name,
                                  'surplus_min_sell_price'
                                )
                              "
                            >
                              Reset
                            </v-btn>
                            <v-btn
                              v-if="
                                surplus_min_sell_price.showSaveButton &&
                                  surplus_min_sell_price_is_valid
                              "
                              small
                              class="btn-save"
                              @click="
                                saveMarket(
                                  market.name,
                                  'surplus_min_sell_price',
                                  market.surplus_min_sell_price
                                )
                              "
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <span
                      >This feature is not available in your current
                      subscription.</span
                    >
                  </v-tooltip>
                </div>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <p class="title text-xs-center">Basic settings</p>
              <p class="text-xs-left not-available-message">
                Settings for this market are not available, because is is not in
                your

                <router-link :to="{ name: 'markets' }">
                  current market selection
                </router-link>
                .

                <br /><br /><br />

                However, it does have some funds
                <a href="#" @click.prevent="active_tab = 1">allocated</a>
                to it.
              </p>
            </v-card-text>
          </div>
          </span>
        </div>
      </v-tab-item>
      <v-tab-item :key="2">
        <div style="display: table; width: 100%;">
          <span style="display: table-cell; width: 20px;">
            <span
              :class="['vertical']"
              :style="allocationVertical"
              v-html="market_pair"
            ></span>
          </span>
          <span style="display: table-cell; width: 100%; float: left;">
            <v-card-text ref="allocationInfoBox" style="float: inline-start;">
              <p class="title text-xs-center">Allocation info</p>
              <v-layout v-if="market_allocation.length" row wrap align-center>
                <v-layout row wrap>
                  <v-flex md12 xs12 row class="ma-2">
                    <v-layout
                      v-for="allocation_info in market_allocation"
                      :key="allocation_info.id"
                      row
                      wrap
                    >
                      <v-flex md3 xs6 class="row-title">
                        {{ allocation_info.title }}:
                        <v-icon
                          v-if="
                            allocation_info.title == 'Bag size' &&
                              allocation_info.unit == '%'
                          "
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 13px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.allocations_bag_size.title'),
                                $t('information.allocations_bag_size.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="allocation_info.title == 'Funding health'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 13px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.funding_health_pct.title'),
                                $t('information.funding_health_pct.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                        <v-icon
                          v-if="allocation_info.title == 'Unrealised loss'"
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 13px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.unrealised_losses.title'),
                                $t('information.unrealised_losses.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </v-flex>
                      <v-flex md9 xs6 class="row-value">
                        {{ allocation_info.unit }}
                        {{ allocation_info.value | parseScientific }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout v-else row wrap align-center>
                <p class="not-available-message">
                  No data available
                </p>
              </v-layout>
            </v-card-text>
          </span>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<style scoped>
.max-height {
  max-height: 1120px;
}
.settings-full {
  height: 1100px;
}
.settings-short-advanced {
  height: 500px;
}
.settings-short {
  height: 150px;
}
.allocation-full {
  height: 300px;
}
.allocation-short {
  height: 80px;
}
.v-input.track-mtp-pct-funding-health.v-input--selection-controls.v-input--checkbox.v-input--is-disabled {
  pointer-events: auto;
}
.number-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
.number-input >>> input::-webkit-outer-spin-button,
.number-input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.input-changed.v-input--checkbox
  >>> .v-input__control
  > .v-input__slot
  .v-label {
  color: #fad35f;
}
.input-changed-color {
  color: #fad35f !important;
}
.input-changed >>> .v-input__icon--append {
  margin-top: 5px;
}
.input-changed.v-input--switch >>> .v-input__control > .v-input__slot {
  border: 4px solid #fad35f;
  padding: 5px;
  border-radius: 5px;
}
.input-changed >>> .v-input__control > .v-input__slot > .v-text-field__slot {
  border: 4px solid #fad35f;
  color: #fad35f !important;
  caret-color: #fad35f !important;
}
.input-changed-section {
  border: 4px solid #fad35f;
  border-radius: 5px;
}
.input-saved-color {
  color: #7ec171 !important;
}
.input-saved-section {
  border: 4px solid #7ec171;
  border-radius: 5px;
}
.input-saved >>> .v-input__icon--append {
  margin-top: 5px;
}
.input-saved >>> .v-input__control > .v-input__slot > .v-text-field__slot {
  border: 4px solid #7ec171;
}
.input-saved.v-input--switch >>> .v-input__control > .v-input__slot {
  border: 4px solid #7ec171;
  padding: 5px;
  border-radius: 5px;
}
.input-saved.v-input--checkbox >>> .v-input__control > .v-input__slot .v-label {
  color: #7ec171;
}
.input-error-color {
  color: #ed4242 !important;
}
.input-error-section {
  border: 4px solid #ed4242;
  border-radius: 5px;
}
.input-error >>> .v-input__icon--append {
  margin-top: 5px;
}
.input-error.v-input--switch >>> .v-input__control > .v-input__slot {
  border: 4px solid #ed4242;
  padding: 5px;
  border-radius: 5px;
}
.input-error >>> .v-input__control > .v-input__slot > .v-text-field__slot {
  border: 4px solid #ed4242;
  color: #ed4242 !important;
  caret-color: #ed4242 !important;
}
.input-error.v-input--checkbox >>> .v-input__control > .v-input__slot .v-label {
  color: #ed4242;
}
.input-saved-text {
  color: #7ec171;
  font-weight: bold;
  visibility: visible;
}

.btn-reset {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #ed4242 0%, #ed4242 100%);
  border-radius: 30px;
  margin: 0px 6px 0px;
  box-shadow: none !important;
}
.btn-save {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #85c778 0%, #7ec171 100%);
  border-radius: 30px;
  margin: 0px 6px 0px;
  box-shadow: none !important;
}
>>> .v-tabs__div {
  text-transform: none !important;
}
>>> .v-input__slot::before {
  border-style: none !important;
}
>>> .v-text-field.v-input--is-focused
  > .v-input__control
  > .v-input__slot::after {
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
}
>>> .theme--light.v-text-field input {
  color: #103a84;
}
.theme--light .vertical {
  width: 20px;
  float: left;
  writing-mode: vertical-lr;
  text-orientation: mixed;
  overflow: hidden;
  margin-right: 2px;
  margin-top: 15px;
  color: #7395d0;
  opacity: 0.3;
}
.theme--light .mtp-pct--title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #8691a4;
}
.theme--light .setting-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #8691a4;
  opacity: 0.8;
}
.theme--light .setting-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #8691a4;
}
.theme--light
  >>> .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  .v-text-field__suffix {
  color: #103a84;
}

.theme--light
  >>> .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot {
  background: #f0f2f5;
  box-shadow: inset 1px 1px 3px rgba(51, 89, 163, 0.34);
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
>>> .theme--light .v-input__append-inner .v-icon {
  font-size: 18px;
  color: #8691a4 !important;
}
>>> .theme--light .v-input__append-outer .v-icon {
  font-size: 18px;
  color: #8691a4 !important;
}

>>> .theme--light.switch-with-message .v-messages__message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #8691a4;
  opacity: 0.8;
  margin-left: 46px;
}
>>> .theme--light.checkbox-with-message .v-messages__message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #8691a4;
  opacity: 0.8;
  margin-left: 46px;
}

>>> .theme--light.v-input--switch .v-label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #8691a4;
}
>>> .theme--light.v-input--checkbox .v-label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #8691a4;
}
>>> .v-text-field .v-label.v-label--active {
  top: 0;
}
>>> .theme--light.v-text-field .v-label {
  color: #8691a4;
  margin-left: 3px;
}
.theme--light .adv-subheading {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #103a84;
}
>>> .theme--light .v-tabs__wrapper {
  padding-top: 0px;
}
>>> .theme--light.v-tabs__bar {
  background-color: #e6efff !important;
}
>>> .theme--light .v-tabs__item {
  color: #7395d0;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: none !important;
}
>>> .theme--light .v-tabs__item--active {
  color: #103a84 !important;
}
.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
.theme--light .row-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
.theme--light .row-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
}
.theme--light .not-available-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #103a84;
}
>>> .theme--light .v-text-field input {
  color: #103a84;
}

.theme--dark .vertical {
  width: 20px;
  float: left;
  writing-mode: vertical-lr;
  text-orientation: mixed;
  overflow: hidden;
  margin-right: 2px;
  margin-top: 15px;
  color: #e9e9e9;
  opacity: 0.3;
}
.theme--dark .not-available-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #ffffff;
}
.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #e9e9e9;
}
.theme--dark .title a {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #e9e9e9;
}
.theme--dark .row-value {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
}
.theme--dark .row-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark.v-text-field input {
  color: #e9e9e9;
}
.theme--dark
  >>> .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot {
  background: #303030;
  box-shadow: inset 1px 1px 3px rgba(28, 28, 28, 0.34);
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
>>> .theme--dark .v-input__append-inner .v-icon {
  font-size: 18px;
  color: #959596 !important;
}
>>> .theme--dark .v-input__append-outer .v-icon {
  font-size: 18px;
  color: #959596 !important;
}

>>> .theme--dark.switch-with-message .v-messages__message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #959596;
  opacity: 0.8;
  margin-left: 46px;
}
>>> .theme--dark.checkbox-with-message .v-messages__message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #959596;
  opacity: 0.8;
  margin-left: 46px;
}
>>> .theme--dark.v-input--switch .v-label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #959596;
}
>>> .theme--dark.v-input--checkbox .v-label {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #959596;
}
>>> .theme--dark.v-text-field .v-label {
  color: #8691a4 !important;
  margin-left: 3px;
}
.theme--dark .adv-subheading {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #e9e9e9;
}
>>> .theme--dark .v-tabs__wrapper {
  padding-top: 0px;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #454547 !important;
}
>>> .theme--dark .v-tabs__item {
  color: #959596;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: none !important;
}
>>> .theme--dark .v-tabs__item--active {
  color: #ffffff !important;
}
>>> .theme--light .v-text-field input {
  color: #e9e9e9;
}
.theme--dark .setting-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #959596;
  opacity: 0.8;
}
.theme--dark .setting-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.02em;
  color: #959596;
}

@media (max-width: 760px) {
  .settings-full {
    height: 1300px;
  }
  .settings-short-advanced {
    height: 600px;
  }
  .max-height {
    max-height: 1350px;
  }
  >>>.v-input--checkbox .v-label {
    display: block;
  }
  >>> .track_mtp_pct_funding_health .v-label {
    display: block !important;
  }
}
</style>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { mapGetters } from "vuex";
import Vue from "vue";

export default {
  props: {
    market: Object,
    checkOnlyDisable: Boolean
  },
  data: function() {
    return {
      do_surplus_selling: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      surplus_min_sell_price: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      aggressiveness_pct: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      max_buy_price: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      min_sell_price: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      max_sell_price_hint: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      min_trade_profit_pct: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      bem_pct: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      track_mtp_pct: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      do_trsl_buy: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      do_trailing_stop_loss: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      allow_buy_above_trsl: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },
      hodl_amount: {
        showSaveButton: false,
        showDataSaved: false,
        showDataSavedError: false
      },

      min_sell_price_is_valid: true,
      max_sell_price_hint_is_valid: true,
      min_trade_profit_pct_is_valid: true,
      bem_pct_is_valid: true,
      max_buy_price_is_valid: true,
      aggressiveness_pct_is_valid: true,
      surplus_min_sell_price_is_valid: true,
      hodl_amount_is_valid: true,

      market_allocation: [],

      inputChanged: "input-changed",
      showDataSaved: "input-saved",
      showInputError: "input-error",
      showDataSavedText: "input-saved-text",
      showDataSavedTextHide: "input-saved-text-hide",

      active_tab: 0,
      showAdvancedValue: null,

      settingsVertical: {},
      allocationVertical: {}
    };
  },
  mounted() {
    this.matchHeight();
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      userSubscriptionHasMarketFeature: "auth/userSubscriptionHasMarketFeature",
      marketFeatures: "auth/marketFeatures",
      userSubscriptionMaxAggressiveness:
        "auth/userSubscriptionMaxAggressiveness",
      themeDark: "settings/darkmode"
    }),
    track_mtp_pct_invert: {
      get() {
        return !this.market.track_mtp_pct;
      },
      set(newValue) {
        this.market.track_mtp_pct = !newValue;
      }
    },
    track_mtp_pct_all_time_high: {
      get() {
        return this.market.track_mtp_pct == 2 || this.market.track_mtp_pct == 4;
      },
      set(newValue) {
        if (newValue) {
          this.market.track_mtp_pct = this.track_mtp_pct_funding_health ? 4 : 2;
        } else {
          this.market.track_mtp_pct = this.track_mtp_pct_funding_health ? 3 : 1;
        }
      }
    },
    track_mtp_pct_funding_health: {
      get() {
        return this.market.track_mtp_pct == 3 || this.market.track_mtp_pct == 4;
      },
      set(newValue) {
        if (newValue) {
          this.market.track_mtp_pct = this.track_mtp_pct_all_time_high ? 4 : 3;
        } else {
          this.market.track_mtp_pct = this.track_mtp_pct_all_time_high ? 2 : 1;
        }
      }
    },
    showAdvanced: {
      get: function() {
        if (this.showAdvancedValue == null) {
          return this.user.subscription_name != "Trial period";
        }
        return this.showAdvancedValue;
      },
      set: function(newValue) {
        this.showAdvancedValue = newValue;
      }
    },
    sliderColor() {
      return this.themeDark ? "#ffffff" : "#103A84";
    },
    allowShowSettingTab() {
      if (this.checkOnlyDisable) {
        return this.market.enabled;
      } else {
        return (
          this.market.enabled ||
          (this.market.hasOwnProperty("has_allocations") &&
            this.market.has_allocations === true)
        );
      }
    },
    advancedTitle() {
      return this.showAdvanced ? "hide" : "show";
    },
    market_pair() {
      let title = this.market.target_currency + "/" + this.market.base_currency;
      let result = title;
      for (let i = 0; i < 25; i++) {
        result = result + "&nbsp;&nbsp;&nbsp;" + title;
      }
      return result;
    }
  },
  created: async function() {
    const oldNames = [
      "surplus_min_sell_price",
      "aggressiveness_pct",
      "min_trade_profit_pct",
      "max_buy_price",
      "min_sell_price",
      "max_sell_price_hint",
      "do_trailing_stop_loss",
      "do_trsl_buy",
      "allow_buy_above_trsl",
      "bem_pct",
      "track_mtp_pct",
      "do_surplus_selling",
      "hodl_amount"
    ];
    Object.keys(this.market).forEach(key => {
      if (oldNames.includes(key)) {
        this.market[key + "_old"] = this.market[key];
      }
    });

    if (
      this.market.market_knowledge_b == null ||
      this.market.market_knowledge_b.mtp_pct == null ||
      !this.market.market_knowledge_b.hasOwnProperty("mtp_pct")
    ) {
      this.market.market_knowledge_b = { mtp_pct: 1 };
    }
    await axios
      .get(
        "/api/v1/markets/allocation/" +
          this.market.exchange +
          "/" +
          this.market.name
      )
      .then(res => {
        this.market_allocation = res.data;
        this.$nextTick(() => {
          this.matchHeight();
        });
      });
  },
  watch: {
    showAdvanced: function() {
      this.$nextTick(() => {
        this.matchHeight();
      });
    },
    active_tab: function() {
      this.$nextTick(() => {
        this.matchHeight();
      });
    }
  },
  methods: {
    matchHeight() {
      setTimeout(() => {
        var heightSettingsString =
          this.$refs["settings-box"].clientHeight - 30 + "px";
        Vue.set(this.settingsVertical, "height", heightSettingsString);
        var heightAllocationString =
            (this.$refs.allocationInfoBox.clientHeight - 30) + "px";
        Vue.set(this.allocationVertical, "height", heightAllocationString);
      }, 0);
    },
    toggleShowAdvanced() {
      return (this.showAdvanced = !this.showAdvanced);
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    setAggressiveness(market, value, marketSettings) {
      if (value && !isNaN(value) && value > 0 && value <= 220) {
        if (this.userSubscriptionMaxAggressiveness && this.user.id > 10536) {
          if (value <= this.userSubscriptionMaxAggressiveness) {
            market.aggressiveness_pct = value;
          }
        } else {
          market.aggressiveness_pct = value;
        }
      }
      this.changedMarketSettings(market.name, marketSettings);
    },
    changedMarketSettings: function(marketName, marketSettings) {
      this.showSaveButton(marketSettings, true);
    },
    resetSettings: function(marketName, marketSetting) {
      this.market[marketSetting] = this.market[marketSetting + "_old"];
      this.showSaveButton(marketSetting, false, false);
    },
    showSaveButton(
      marketSetting,
      showSaveBtn = false,
      showDataSaved = false,
      showDataSavedError = false
    ) {
      switch (marketSetting) {
        case "do_surplus_selling":
          this.do_surplus_selling.showSaveButton = showSaveBtn;
          this.do_surplus_selling.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.do_surplus_selling.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.do_surplus_selling.showDataSavedError = true;
            setTimeout(
              () => (this.do_surplus_selling.showDataSavedError = false),
              2000
            );
          }
          break;
        case "surplus_min_sell_price":
          this.surplus_min_sell_price.showSaveButton = showSaveBtn;
          this.surplus_min_sell_price.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.surplus_min_sell_price.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.surplus_min_sell_price.showDataSavedError = true;
            setTimeout(
              () => (this.surplus_min_sell_price.showDataSavedError = false),
              2000
            );
          }
          break;
        case "aggressiveness_pct":
          this.aggressiveness_pct.showSaveButton = showSaveBtn;
          this.aggressiveness_pct.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.aggressiveness_pct.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.aggressiveness_pct.showDataSavedError = true;
            setTimeout(
              () => (this.aggressiveness_pct.showDataSavedError = false),
              2000
            );
          }
          break;
        case "max_buy_price":
          this.max_buy_price.showSaveButton = showSaveBtn;
          this.max_buy_price.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.max_buy_price.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.max_buy_price.showDataSavedError = true;
            setTimeout(
              () => (this.max_buy_price.showDataSavedError = false),
              2000
            );
          }
          break;
        case "min_sell_price":
          this.min_sell_price.showSaveButton = showSaveBtn;
          this.min_sell_price.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.min_sell_price.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.min_sell_price.showDataSavedError = true;
            setTimeout(
              () => (this.min_sell_price.showDataSavedError = false),
              2000
            );
          }
          break;
        case "max_sell_price_hint":
          this.max_sell_price_hint.showSaveButton = showSaveBtn;
          this.max_sell_price_hint.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.max_sell_price_hint.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.max_sell_price_hint.showDataSavedError = true;
            setTimeout(
              () => (this.max_sell_price_hint.showDataSavedError = false),
              2000
            );
          }
          break;
        case "min_trade_profit_pct":
          this.min_trade_profit_pct.showSaveButton = showSaveBtn;
          this.min_trade_profit_pct.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.min_trade_profit_pct.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.min_trade_profit_pct.showDataSavedError = true;
            setTimeout(
              () => (this.min_trade_profit_pct.showDataSavedError = false),
              2000
            );
          }
          break;
        case "bem_pct":
          this.bem_pct.showSaveButton = showSaveBtn;
          this.bem_pct.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.bem_pct.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.bem_pct.showDataSavedError = true;
            setTimeout(() => (this.bem_pct.showDataSavedError = false), 2000);
          }
          break;
        case "track_mtp_pct":
          this.track_mtp_pct.showSaveButton = showSaveBtn;
          this.track_mtp_pct.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.track_mtp_pct.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.track_mtp_pct.showDataSavedError = true;
            setTimeout(
              () => (this.track_mtp_pct.showDataSavedError = false),
              2000
            );
          }
          break;
        case "do_trsl_buy":
          this.do_trsl_buy.showSaveButton = showSaveBtn;
          this.do_trsl_buy.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.do_trsl_buy.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.do_trsl_buy.showDataSavedError = true;
            setTimeout(
              () => (this.do_trsl_buy.showDataSavedError = false),
              2000
            );
          }
          break;
        case "do_trailing_stop_loss":
          this.do_trailing_stop_loss.showSaveButton = showSaveBtn;
          this.do_trailing_stop_loss.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.do_trailing_stop_loss.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.do_trailing_stop_loss.showDataSavedError = true;
            setTimeout(
              () => (this.do_trailing_stop_loss.showDataSavedError = false),
              2000
            );
          }
          break;
        case "allow_buy_above_trsl":
          this.allow_buy_above_trsl.showSaveButton = showSaveBtn;
          this.allow_buy_above_trsl.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(
              () => (this.allow_buy_above_trsl.showDataSaved = false),
              2000
            );
          }
          if (showDataSavedError) {
            this.allow_buy_above_trsl.showDataSavedError = true;
            setTimeout(
              () => (this.allow_buy_above_trsl.showDataSavedError = false),
              2000
            );
          }
          break;
        case "hodl_amount":
          this.hodl_amount.showSaveButton = showSaveBtn;
          this.hodl_amount.showDataSaved = showDataSaved;
          if (showDataSaved) {
            setTimeout(() => (this.hodl_amount.showDataSaved = false), 2000);
          }
          if (showDataSavedError) {
            this.hodl_amount.showDataSavedError = true;
            setTimeout(
              () => (this.hodl_amount.showDataSavedError = false),
              2000
            );
          }
          break;
        default:
      }
    },
    saveMarket: function(name, market, data) {
      /**
       * do_trsl_buy (handled by Vue)
       *
       * from 0 to 2 (by user, action: turn on)
       * from 2 to 1 (by system, action: activated)
       * from 1 to 0 (by user, action: turn off)
       */
      if (market == "do_trsl_buy") {
        if (data !== undefined && data === 1 && data === 0) {
          data = 2;
        }
      }

      if (market == "track_mtp_pct") {
        if (data == true) {
          data = 1;
        } else if (data == false) {
          data = 0;
        }
      }

      const changedMarketSettings = {};
      changedMarketSettings[market] = data;

      try {
        axios
          .patch("/api/v1/markets/" + encodeURI(name), changedMarketSettings)
          .then(response => {
            if (response.status === 200) {
              this.showSaveButton(market, false, true);
              this.market[market] = response.data[market];
              this.market[market + "_old"] = this.market[market];
              this.$store.dispatch("markets/updateMarket", this.market);
              return true;
            }
            this.market[market] = this.market[market + "_old"];
            this.$store.dispatch("markets/updateMarket", this.market);
            this.showSaveButton(market, false, false, true);
            return false;
          })
          .catch(error => {
            this.showSaveButton(market, false, false, true);
            this.market[market] = this.market[market + "_old"];
            this.$store.dispatch("markets/updateMarket", this.market);
            return false;
          });
      } catch (error) {
        this.showSaveButton(market, false, false, true);
        this.market[market] = this.market[market + "_old"];
        this.$store.dispatch("markets/updateMarket", this.market);
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/markets/ActiveMarketsItemAdvanced.vue